module.exports = __webpack_public_path__ + "img/icon_line_a.8dc02cb.svg";